<template>
  <router-link class="c-car-type" :to="{ name: 'providerscambiocarinfo' }">
    <img
      class="c-car-type__image"
      src="/images/cambio-car.png"
      alt="Car Type"
    />
    <div class="c-car-type__label">{{ label }}</div>
    <o-icon class="c-car-type__chevron" icon="chevron-right" />
  </router-link>
</template>

<script>
export default {
  name: 'CambioCarType',

  props: {
    label: String
  }
}
</script>

<style lang="scss">
.c-car-type {
  align-items: center;
  color: inherit !important;
  display: flex;
  padding: 0.8rem 0;
}

.c-car-type__image {
  display: block;
  height: auto;
  margin: 0 2.4rem 0 0 !important;
  width: 6.4rem;
}

.c-car-type__label {
  flex: 1 1 0;
}
</style>
